/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Beschaeftigungsgenehmigungids2Inputs */



/**

* @param {_Field_Beschaeftigungsgenehmigungids2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_beschaeftigungsgenehmigungids2 = /** @type {((inputs?: _Field_Beschaeftigungsgenehmigungids2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Beschaeftigungsgenehmigungids2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Beschäftigungsgenehmigungen")
});
export { _field_beschaeftigungsgenehmigungids2 as "_field_beschaeftigungsgenehmigungIDs" }